import { render } from "./sel-mp4-video.vue?vue&type=template&id=272e81f1&scoped=true"
import script from "./sel-mp4-video.vue?vue&type=script&lang=js"
export * from "./sel-mp4-video.vue?vue&type=script&lang=js"

import "./sel-mp4-video.vue?vue&type=style&index=0&id=272e81f1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272e81f1"]])

export default __exports__